var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddToDash = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  fillRule: "evenodd",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.25 3c0-.966.784-1.75 1.75-1.75h10c.966 0 1.75.784 1.75 1.75v5h-1.5V3.5H2.75V13c0 .138.112.25.25.25h4v1.5H3A1.75 1.75 0 0 1 1.25 13V3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.75 9H7v1.5H4.75a.75.75 0 0 1 0-1.5zM4 6.25a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7 6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5A.75.75 0 0 1 7 6.25zM12 14.75a.75.75 0 0 1-.75-.75v-1.25H10a.75.75 0 0 1 0-1.5h1.25V10a.75.75 0 0 1 1.5 0v1.25H14a.75.75 0 0 1 0 1.5h-1.25V14a.75.75 0 0 1-.75.75z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddToDash);
export default ForwardRef;